module.exports = __webpack_public_path__ + "img/add_os.6d6be6de.png";